module.exports = __webpack_public_path__ + "media/images/near_to_you_mock_image-a7785ecd610afe74b07803266f446fff.jpg";